/**
 * Kiểu chữ
 */
export default {
    Regular: 0,
    Bold: 1,
    Italic: 2,
    BoldItalic: 3,
}